import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatTabsModule} from '@angular/material/tabs';
import {MatStepperModule} from '@angular/material/stepper';
import {MatIconModule} from '@angular/material/icon';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatTabsModule,
    MatStepperModule,
    MatIconModule
  ],
  exports: [
    MatTabsModule,
    MatStepperModule,
    MatIconModule
  ]
})
export class MaterialModule {
}
